export const getZapposRebrandTailwindColor = (tailwindColor: string) => {
  if (typeof tailwindColor !== 'string') {
    return tailwindColor;
  }

  return tailwindColor.replace(' / <alpha-value>', '');
};
